import React, { ReactElement, ReactNode } from 'react'
import styled, { CSSProperties } from 'styled-components'

const Label = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
  margin-left: 2px;
`
const Subtitle = styled.div`
  font-size: 0.9rem;
  margin-left: 2px;
  margin-top: 4px;
`
const Row = styled.div`
  display: flex;
  align-items: center;
`
const InputContainer = styled.div`
  display: block;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`
export interface IInputGroupProps {
  children: ReactNode[]
  className?: string
  label?: string
  subtitle?: string
  style?: CSSProperties
}

function InputGroup(props: IInputGroupProps): ReactElement {
  const {
    children, className, label, subtitle, style,
  } = props

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Row className={className} style={style}>
        {children.length > 1 ? (
          children.map((child, index) => {
            if (!child) return null
            const key = `${index}`
            return <InputContainer key={key}>{child}</InputContainer>
          })
        ) : (
          <InputContainer>{children}</InputContainer>
        )}
      </Row>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </div>
  )
}
export default InputGroup
